import { getPlatformFromUserAgent } from "./platformUtils";

import {
  log as logAppPromoInteractionSignal,
  AvroOptional,
} from "@indeed/signals-schema/com/indeed/signals/schema/magua/AppPromoInteraction";

type AppPromoInteractionParams = Parameters<typeof logAppPromoInteractionSignal>[0];

export interface AppPromoInteractionLoggerOptions {
  hostId: AppPromoInteractionParams["hostId"];
  pageId: AppPromoInteractionParams["pageId"];
  campaign?: string;
  experiments?: string[];
  promoInstanceInSession?: number;
  promoInstanceInMonth?: number;
}

export interface AppPromoInteractionContext {
  ctk: string | undefined;
  mobtk: string | undefined;
  isLoggedIn: boolean | undefined;
  country: string | undefined;
  language: string | undefined;
}

export function logAppPromoInteraction(
  context: AppPromoInteractionContext,
  options: AppPromoInteractionLoggerOptions,
  interactionType: "IMPRESSION" | "CLICK" | "DISMISS" | "EMP_CLICK",
) {
  const { ctk, mobtk, isLoggedIn, country, language } = context;
  const {
    hostId,
    pageId,
    campaign,
    experiments = [],
    promoInstanceInSession,
    promoInstanceInMonth,
  } = options;

  if (!ctk || !mobtk) return;

  const platform = getPlatformFromUserAgent();

  logAppPromoInteractionSignal({
    ctk,
    mobtk,
    isLoggedIn: isLoggedIn ?? false,
    platform: platform.toUpperCase() as "ANDROID" | "IOS",
    hostId,
    pageId,
    campaign: AvroOptional.string(campaign),
    experiments: AvroOptional.array(experiments),
    country: AvroOptional.string(country),
    language: AvroOptional.string(language),
    promoInstanceInSession: AvroOptional.int(promoInstanceInSession),
    promoInstanceInMonth: AvroOptional.int(promoInstanceInMonth),
    interactionType,
  });
}
